module.exports = __webpack_public_path__ + "static/home-692e5a642ccec164e3c31ec40a507bf8.png";